import { cn } from '@workspace/ui/lib/utils'
import { Loader2 } from 'lucide-react'

interface FullScreenStateProps {
  /** Primary message (e.g., "Loading...", "Not found") */
  title: string
  /** Optional secondary message with more detail */
  subtitle?: string
  /** Show a loading spinner above the title */
  loading?: boolean
  /** Additional className for the outer container */
  className?: string
}

export function FullScreenState({ title, subtitle, loading, className }: FullScreenStateProps) {
  return (
    <div className={cn('flex min-h-screen items-center justify-center bg-background', className)}>
      <div className="text-center">
        {loading && <Loader2 className="mx-auto mb-4 size-6 animate-spin text-muted-foreground" />}
        <h1 className="text-xl font-semibold text-foreground">{title}</h1>
        {subtitle && <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>}
      </div>
    </div>
  )
}
